import { ApolloError } from '@apollo/client';
import { datadogRum } from '@datadog/browser-rum';
import { useAuth } from '@guildeducationinc/guild-auth';
import { Server } from '@src/components/GqlProvider/GqlProvider';
import { IMemberUserQuery, useMemberUserQuery } from '@src/generated/gateway/graphql';

/**
 * @name useGetMemberUser
 * @description A hook that gets member user information.
 * @returns An object containing loading, error, and the member user.
 */
const useGetMemberUser = (onGetMemberUserComplete?: (data: IMemberUserQuery) => void) => {
  const { user } = useAuth();

  const onError = (error: ApolloError): void => {
    datadogRum.addError(error, {
      message: `There was an error getting member user info: ${error.message}`,
    });
  };

  const onCompleted = (data: IMemberUserQuery) => {
    onGetMemberUserComplete && onGetMemberUserComplete(data);
  };

  const { data, loading, error } = useMemberUserQuery({
    context: {
      server: Server.GATEWAY,
    },
    variables: { id: user?.id || '' },
    skip: !user?.id,
    onError,
    onCompleted,
  });

  return { memberUser: data?.memberUser, loading, error };
};

export default useGetMemberUser;
